/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Directive, ElementRef, Input, SimpleChanges, OnChanges, OnInit, HostListener } from '@angular/core';
import { CommonService } from '../../services/common.service';
@Directive({
  selector: '[appLoadButton]'
})
export class LoadButtonDirective implements OnInit, OnChanges {
  @Input() saveOperation!: boolean;
  @Input() resetButton!: boolean;

  constructor(private el: ElementRef, private commonService: CommonService) {}

  @HostListener('click') onclick() {
    let save = this.getTranslationWithKey('save');
    this.buttonClicked('<i class="fa fa-spinner"></i>');
    setTimeout(() => {
      this.buttonClicked(save);
    }, 0);
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    let save = this.getTranslationWithKey('save');
    if (changes['saveOperation'] && changes['saveOperation'].currentValue) {
      this.buttonClicked('<i class="icon-sys-enter"></i>');
    } else {
      this.buttonClicked(save);
    }

    if (changes['resetButton']) {
      if (this.el.nativeElement.innerHTML === '<i class="fa fa-spinner"></i>') {
        this.buttonClicked(save);
      }
    }
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  private buttonClicked(content: any) {
    this.el.nativeElement.innerHTML = content;

    /* We will handle this use case in a different way.
     *  The below solution is a breaking change for al existing pages.
     *  So commenting it out for the time being
     */

    /*if (content !== 'Save') {
      this.el.nativeElement.disabled = true;
    }*/
  }
}
